/**
 * Cine poate REVOCA un link de colaborator din interfata.
 *
 * Decizie owner (18.09): «Revocă» iese din ecranul PROFESORULUI — un buton cu iconita de lant rupt,
 * langa «Copiază», se apasa din greseala si opreste un colaborator care lucra. Ramane pentru
 * ADMIN/DBEST, care ajung pe `/colaboratori` prin URL (`ALLOWED_ROLES` al rutei ii include). Endpointul
 * din backend nu se atinge.
 *
 * Lista e „oricine in afara de PROFESOR", nu „doar ADMIN/DBEST": un rol nou trebuie sa ceara explicit
 * sa piarda butonul, nu sa-l primeasca tacut — dar un profesor nu-l primeste NICIODATA.
 */
export function poateRevocaLinkulDeColaborator(rol: string | null | undefined): boolean {
    return rol !== undefined && rol !== null && rol !== 'PROFESOR';
}
